<template>
  <BasePaymentForm
    class="custom-payment-form"
  >
    <template #body>
      <div class="icon form-group mt-2 mb-1 text-success">
        <i class="fas fa-check-circle mb-2"/>
        <span>
          {{ $t('apps.payment.message.paymentsuccess') }}
        </span>
      </div>
      <div class="summary form-group mt-3 mb-0">
        <div class="section">
          <span>
            {{ $t('apps.payment.label.ordernumber') }}:
          </span>
          <span class="text-right">
            {{ transaction.chargeId }}
          </span>
        </div>
        <div class="section">
          <span>
            {{ $t('apps.payment.label.paymentmethod') }}:
          </span>
          <span class="text-right">
            {{ $t(`apps.payment.message.paymentmethod_${transaction.paymentMethod}`) }}
          </span>
        </div>
        <div class="section">
          <span>
            {{ $t('apps.payment.label.payamount') }}:
          </span>
          <span class="text-right">
            {{ getCurrencyWithNumber(numberel(transaction.paidAmount, '0,0.[00]')) }}
          </span>
        </div>
        <!-- <div class="section">
          <span>
            {{ $t('apps.payment.label.downloadfile') }}:
          </span>
          <span class="text-right">
            <button class="no-bg download-btn">
              PDF
            </button>
          </span>
        </div> -->
      </div>
    </template>
    <template #footer-actions>
      <BaseButton
        :text="$t('button.gotohomepage')"
        :className="`btn-web`"
        @click="onClickNext"
      />
    </template>
  </BasePaymentForm>
</template>

<script>
export default {
  props: {
    transaction: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    onClickNext () {
      this.$emit('next')
    },
  },
}
</script>

<style scoped>
.custom-payment-form >>> .form {
  max-width: 494px;
  font-size: 14px;
}

.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon i {
  font-size: 64px;
}

.icon span {
  font-size: 18px;
}

.billing {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.summary {
  display: flex;
  flex-direction: column;
  color: #999696;
  padding-left: 30px;
  padding-right: 30px;
}

.summary .section {
  display: flex;
  justify-content: space-between;
}

.download-btn {
  color: #999696;
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/paymentpackage/Paid.vue